import { ECountry } from '@/shared/enum/country.enum'

/**
 * A map of production urls to their corresponding link.
 * @type {Map<ECountry, string>}
 */
export const mceProductionUrls: Map<ECountry, string> = new Map([
  [ECountry.GT, 'https://paquetes.miclaro.com.gt'],
  [ECountry.CR, 'https://paquetes.miclaro.cr'],
  [ECountry.HN, 'https://paquetes1.miclaro.com.hn'],
  [ECountry.NI, 'https://paquetes1.miclaro.com.ni'],
  [ECountry.SV, 'https://paquetes.miclaro.com.sv']
])

/**
 * A map of stage urls to their corresponding link.
 * @type {Map<ECountry, string>}
 */
export const mceStageUrls: Map<ECountry, string> = new Map([
  [ECountry.GT, 'https://gt.portal-universal.com'],
  [ECountry.CR, 'https://cr.portal-universal.com'],
  [ECountry.HN, 'https://hn.portal-universal.com'],
  [ECountry.NI, 'https://ni.portal-universal.com'],
  [ECountry.SV, 'https://sv.portal-universal.com']
])
